export default __webpack_public_path__ + "static/media/hero-across-bg.33d1a66a.png";